import { stripHtmlTags } from '../sanitize/sanitize';

export class SanitizedSearchParams extends URLSearchParams {
  override get(name: string): string | null {
    const value = super.get(name);
    return value ? stripHtmlTags(value) : value;
  }

  override getAll(name: string): string[] {
    return super.getAll(name).map(value => stripHtmlTags(value));
  }

  override entries(): ReturnType<URLSearchParams['entries']> {
    return this.sanitizedIterator(super.entries());
  }

  override values(): ReturnType<URLSearchParams['values']> {
    return this.sanitizedValueIterator(super.values());
  }

  override forEach(callbackfn: (value: string, key: string, parent: URLSearchParams) => void, thisArg?: unknown): void {
    super.forEach((value, key, parent) => callbackfn.call(thisArg, stripHtmlTags(value), key, parent));
  }

  override toString(): string {
    const params = new URLSearchParams();
    for (const [name, value] of super.entries()) {
      params.append(name, stripHtmlTags(value));
    }
    return params.toString();
  }

  override [Symbol.iterator](): ReturnType<URLSearchParams['entries']> {
    return this.entries();
  }

  private sanitizedIterator(iterator: IterableIterator<[string, string]>): IterableIterator<[string, string]> {
    return {
      next(): IteratorResult<[string, string]> {
        const result = iterator.next();
        if (result.done) return result;
        const [name, value] = result.value;
        return { done: false, value: [name, stripHtmlTags(value)] };
      },
      [Symbol.iterator]() {
        return this;
      },
    };
  }

  private sanitizedValueIterator(iterator: IterableIterator<string>): IterableIterator<string> {
    return {
      next(): IteratorResult<string> {
        const result = iterator.next();
        if (result.done) return result;
        return { done: false, value: stripHtmlTags(result.value) };
      },
      [Symbol.iterator]() {
        return this;
      },
    };
  }
}
